import { render, staticRenderFns } from "./SwitchInset.vue?vue&type=template&id=1bf7812d&scoped=true&"
import script from "./SwitchInset.vue?vue&type=script&lang=js&"
export * from "./SwitchInset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf7812d",
  null
  
)

export default component.exports